<right-panel-details-text-info
    *ngFor="let dimension of partitioningDimensions"
    [label]="dimension.name"
    [text]="dimension.type | titlecase"
    [tooltip]="dimension.type | titlecase"
></right-panel-details-text-info>